import { Component, OnInit, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CSuggestionCreateViewModel } from '../../models/suggestion.models/suggestionCreateViewModel.model';
import { SuggestionService } from '../../services/suggestion.service';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

@Component({
    selector: 'sendSuggestion',
    templateUrl: 'sendSuggestion.component.html'
})
export class SendSuggestionComponent implements OnInit {
    ngOnInit(): void {
    }

    suggestionCreateViewModel: CSuggestionCreateViewModel = new CSuggestionCreateViewModel();

    showLoadingGif: boolean = false;
    showReponseMessage: boolean = false;
    responseMessage: string = '';

    constructor(private formBuilder: FormBuilder, private suggestionService: SuggestionService) {

    }

    email: FormControl = new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$'),
        Validators.maxLength(256)
    ]);

    fullName: FormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(200)
    ]);

    subject: FormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(300)
    ]);

    description: FormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(1000)
    ]);

    recaptcha: FormControl = new FormControl('', [
        Validators.required
    ]);

    suggestionForm: FormGroup = this.formBuilder.group({
        fEmail: this.email,
        fFullName: this.fullName,
        fSubject: this.subject,
        fDescription: this.description,
        fRecaptcha: this.recaptcha
    });


    SendSuggestion() {
        this.showLoadingGif = true;
        this.showReponseMessage = false;
        this.responseMessage = '';

        this.suggestionService.CreateNew(this.suggestionForm.value).subscribe(p => {

            this.suggestionForm.reset();

            this.showLoadingGif = false;
            this.showReponseMessage = true;
            this.responseMessage = 'پیام شما با موفقیت ارسال شد. با تشکر از تماس شما';
        }, p => {
            this.showLoadingGif = false;
            this.showReponseMessage = true;
            this.responseMessage = 'متاسفانه خطایی پیش آمده است. لطفا مجددا سعی نمایید';
        });
    }

}